import MessagingTemplatesPage from '../agency/MessagingTemplates';

export default function AdminMessagingTemplates() {
  return <MessagingTemplatesPage isAdminView />;
}
